import { IngredientUnits } from '../ingredients/IngredientEntity';
export var SuppliersWithDefaultIngredients;
(function (SuppliersWithDefaultIngredients) {
    SuppliersWithDefaultIngredients["MERCADONA"] = "mercadona";
    SuppliersWithDefaultIngredients["MAKRO"] = "makro";
})(SuppliersWithDefaultIngredients || (SuppliersWithDefaultIngredients = {}));
export const defaultSupplierDefaultIngredientData = {
    name: '',
    nameInNote: '',
    vatPercentage: 0,
    unit: IngredientUnits.KG,
    formatQuantity: 0,
    pricePerUnit: 0,
};
//# sourceMappingURL=SupplierDefaultIngredientEntity.js.map